import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import HeaderStatic from "./components/Header/HeaderStatic";
import Cover from './components/Cover/Cover';
import Projects from "./pages/Projects/Projects";

function App() {

  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <div>
              <Helmet>
                <title>Cameron Jiang</title>
                <meta name="description" content="Cameron Jiang" />
              </Helmet>
              <Header />
              <Cover />
            </div>
          } />

          <Route path="/projects" element={
            <div>
              <Helmet>
                <title>Cameron Jiang</title>
                <meta name="description" content="Cameron Jiang" />
              </Helmet>
              <HeaderStatic />
              <Projects />
            </div>
          } />

          <Route path="/about" element={
            <div>
              <Helmet>
                <title>Cameron Jiang</title>
                <meta name="description" content="Cameron Jiang" />
              </Helmet>
              <HeaderStatic />
              <Cover />
            </div>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;